module.exports = __webpack_public_path__ + "cb6522a463ae596c455527449a6c4f04.png";